import {
    CourseContainerResponseData,
    getCourseContainerBySlug,
} from '@yandex-int/k-common/client/api/defs/get-course-container-by-slug';
import { QueryConfig, useQuery } from 'react-query';
import { useMemo } from 'react';

type Params = {
    slug: string;
};

export function useCourseContainerDescriptionQuery(
    queryParams: Params,
    queryConfig?: QueryConfig<CourseContainerResponseData>
) {
    const { slug } = queryParams;

    const initialQuery = useQuery<CourseContainerResponseData>(
        ['courseContainersDetails', slug],
        () => getCourseContainerBySlug(queryParams),
        {
            enabled: slug,
            staleTime: Infinity,
            ...queryConfig,
        }
    );

    const data = useMemo(() => {
        return initialQuery.data?.results?.[0] || {};
    }, [initialQuery.data]);

    return { ...initialQuery, data };
}
